namespace $.$$ {

	/**
	 * Eve Card component
	 * 
	 * Simple card with title and content
	 * Based on eve_surface for consistent styling
	 * 
	 * @example
	 * ```tree
	 * <= My_card $eve_card
	 *     title \My Card Title
	 *     content /
	 *         <= Some_text $mol_paragraph
	 *             title \Card content goes here
	 * ```
	 */
	export class $eve_card extends $.$eve_card {
		
	}
}

